import { FileManager } from "./types";

const defaultState = {
    files: [], //{ids, comment, status}
    uuid: null,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case FileManager.SET_UPLOADED_FILES:
            return {
                ...state,
                files: action.files,
                uuid: "uuid" in action ? action.uuid : state.uuid,
            };
        default:
            return state;
    }
};
